var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem13C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.5 43.2h-33.7c.1 0 1.2 1.9 3.2 5.7 2.1 3.8 4.4 9.6 7.1 17.2 2.7 7.6 5 17.2 7.1 28.5 2 11.4 3.1 24.7 3.2 39.8-.1 15.1-1.2 28.4-3.2 39.8-2.1 11.4-4.4 21-7.1 28.6-2.7 7.7-5 13.4-7.1 17.2-2 3.9-3.1 5.8-3.2 5.8h33.7c.1 0 1.2-1.9 3.2-5.8 2.1-3.8 4.4-9.6 7.1-17.2 2.7-7.7 5-17.2 7.1-28.6 2-11.4 3.1-24.7 3.2-39.8-.1-15.1-1.2-28.4-3.2-39.8-2.1-11.4-4.4-20.9-7.1-28.5-2.7-7.7-5-13.4-7.1-17.2-2.1-3.8-3.1-5.7-3.2-5.7z",
    style: {
      fill: "#b3b3b3"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.4 65.9c-2.7-7.7-5.1-13.4-7.1-17.3-2.1-3.9-3.2-5.9-3.3-5.9l-.2-.2h-35.5l.7 1.1c0-.1.1.1.4.4.6.9 2 3.4 4.1 7.7 2.1 4.3 4.3 10.2 6.8 17.8 2.5 7.5 4.6 16.7 6.5 27.6 1.9 10.9 2.8 23.4 2.8 37.5-.1 15.1-1.2 28.4-3.2 39.7-2 11.4-4.3 20.8-7 28.4-1.3 3.8-2.6 7.2-3.8 10-1.2 2.8-2.4 5.2-3.3 7.1-1 1.9-1.8 3.4-2.4 4.4-.2.4-.4.7-.5 1.1l-.4.2-.7 1.3h35.5l.2-.4c.1-.1 1.2-2 3.3-5.9 2-3.9 4.4-9.7 7.1-17.3 2.7-7.7 5.1-17.2 7.1-28.7 2.1-11.4 3.2-24.7 3.3-39.9-.1-15.2-1.2-28.5-3.3-39.9-2-11.6-4.4-21.1-7.1-28.8m-7.3-14.3c2.1 4.3 4.4 10.2 6.9 17.8 2.5 7.5 4.6 16.7 6.5 27.6 1.9 10.9 2.8 23.4 2.8 37.5-.1 15.1-1.2 28.4-3.2 39.7-2.1 11.4-4.5 20.8-7.2 28.4-1.3 3.8-2.5 7.2-3.7 10-1.2 2.9-2.3 5.2-3.2 7.1-1 1.9-1.8 3.4-2.4 4.4-.3.4-.5.7-.7 1.1h-32c1-1.5 2.5-4.5 4.6-9 2.1-4.5 4.4-10.6 6.7-18.2 2.4-7.6 4.4-16.7 6.1-27.2 1.7-10.6 2.6-22.7 2.6-36.3-.1-13.4-.9-25.4-2.6-36-1.6-10.5-3.6-19.5-6-27.1-2.3-7.6-4.5-13.7-6.6-18.2-2.1-4.6-3.7-7.7-4.7-9.3h31.9c.7.9 2.1 3.5 4.2 7.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.9 43.2h-33.5c.1 0 1.2 1.9 3.2 5.7 2.1 3.8 4.4 9.6 7.1 17.2 2.7 7.7 5 17.2 7.1 28.5 2 11.4 3.1 24.7 3.2 39.8-.1 15.1-1.2 28.4-3.2 39.8-2.1 11.4-4.4 21-7.1 28.6-2.7 7.7-5 13.4-7.1 17.2-2 3.9-3.1 5.8-3.2 5.8h33.5c.1 0 1.2-1.9 3.3-5.8 2-3.8 4.4-9.6 7.1-17.2 2.7-7.7 5.1-17.2 7.1-28.6 2.1-11.4 3.2-24.7 3.3-39.8-.1-15.1-1.2-28.4-3.3-39.8-2-11.4-4.4-20.9-7.1-28.5-2.7-7.7-5.1-13.4-7.1-17.2-2.1-3.8-3.2-5.7-3.3-5.7z",
    style: {
      fill: "#595959"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M429 65.9c-2.7-7.7-5.1-13.4-7.1-17.3-2.1-3.9-3.2-5.9-3.3-5.9l-.2-.2h-35.5l.7 1.1c.1-.1.1.1.2.4.7.9 2.1 3.4 4.2 7.7 2.1 4.3 4.4 10.2 6.9 17.8 2.5 7.5 4.6 16.7 6.5 27.6 1.9 10.9 2.8 23.4 2.8 37.5-.1 15.1-1.2 28.4-3.2 39.7-2.1 11.4-4.5 20.8-7.2 28.4-1.3 3.8-2.5 7.2-3.7 10-1.2 2.8-2.3 5.2-3.2 7.1-1 1.9-1.8 3.4-2.4 4.4-.3.4-.5.7-.7 1.1-.1.1-.1.2-.2.2l-.7 1.3h35.5l.2-.4c.1-.1 1.2-2 3.3-5.9 2-3.9 4.4-9.7 7.1-17.3 2.7-7.7 5.1-17.2 7.1-28.7 2.1-11.4 3.2-24.7 3.3-39.9-.1-15.2-1.2-28.5-3.3-39.9-2-11.6-4.3-21.1-7.1-28.8m-7.3-14.3c2.1 4.3 4.4 10.2 6.9 17.8 2.5 7.5 4.6 16.7 6.5 27.6 1.9 10.9 2.9 23.4 2.9 37.5-.1 15.1-1.2 28.4-3.2 39.7-2.1 11.4-4.5 20.8-7.2 28.4-1.3 3.8-2.5 7.2-3.7 10-1.2 2.9-2.3 5.2-3.2 7.1-1 1.9-1.8 3.4-2.4 4.4-.3.4-.5.7-.7 1.1h-32c1-1.5 2.5-4.5 4.6-9 2.1-4.5 4.4-10.6 6.7-18.2 2.4-7.6 4.4-16.7 6.1-27.2 1.7-10.6 2.6-22.7 2.6-36.3-.1-13.4-.9-25.4-2.6-36-1.6-10.5-3.6-19.5-6-27.1-2.3-7.6-4.5-13.7-6.6-18.2-2.1-4.6-3.7-7.7-4.7-9.3h31.9c.6.9 1.9 3.5 4.1 7.7z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 379.757,
    y: 107.299,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     B  "), /*#__PURE__*/React.createElement("text", {
    x: 379.757,
    y: 124.799,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     R  "), /*#__PURE__*/React.createElement("text", {
    x: 379.757,
    y: 142.149,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     A  "), /*#__PURE__*/React.createElement("text", {
    x: 380.212,
    y: 159.749,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     S  "), /*#__PURE__*/React.createElement("text", {
    x: 380.212,
    y: 177.199,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     S  "), /*#__PURE__*/React.createElement("text", {
    x: 418.101,
    y: 115.449,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     I  "), /*#__PURE__*/React.createElement("text", {
    x: 414.456,
    y: 132.849,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     R  "), /*#__PURE__*/React.createElement("text", {
    x: 414.001,
    y: 150.449,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     O  "), /*#__PURE__*/React.createElement("text", {
    x: 414.456,
    y: 167.849,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     N  "), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m363.3 73.3-5.5-15.7c-2.2.8-3.8 2.2-4.7 4.2-1 2-1.1 4.1-.4 6.4.6 1.8 1.6 3.1 3 4.1 1.4 1 3 1.5 4.7 1.5 1 .1 2-.1 2.9-.5zm69.6-14.6c-1.5-1-3.1-1.5-4.8-1.5-.9 0-1.8.2-2.7.5l5.5 15.7c2.2-.8 3.9-2.2 4.8-4.2 1-2 1.1-4.1.3-6.4-.7-1.8-1.7-3.2-3.1-4.1zm2.6 141c-1-2-2.6-3.4-4.7-4.2l-5.5 15.7c1 .4 1.9.5 2.8.5 1.8-.1 3.3-.6 4.7-1.5 1.4-.9 2.4-2.3 3-4.1.8-2.3.7-4.4-.3-6.4zm-72.1-4.1c-.9-.3-1.8-.5-2.7-.5-1.8 0-3.4.5-4.8 1.5s-2.4 2.3-3 4.1c-.8 2.2-.7 4.4.3 6.4s2.6 3.4 4.8 4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M631.6 43.2h-33.7c-.1 0-1.2 1.9-3.2 5.7-2.1 3.8-4.4 9.6-7.1 17.2s-5 17.2-7.1 28.5c-2 11.4-3.1 24.7-3.2 39.8.1 15.1 1.2 28.4 3.2 39.8 2.1 11.4 4.4 21 7.1 28.6 2.7 7.7 5 13.4 7.1 17.2 2 3.9 3.1 5.8 3.2 5.8h33.7c-.1 0-1.2-1.9-3.2-5.8-2.1-3.8-4.4-9.6-7.1-17.2-2.7-7.7-5-17.2-7.1-28.6-2-11.4-3.1-24.7-3.2-39.8.1-15.1 1.2-28.4 3.2-39.8 2.1-11.4 4.4-20.9 7.1-28.5 2.7-7.7 5-13.4 7.1-17.2 2-3.8 3.1-5.7 3.2-5.7z",
    style: {
      fill: "#b3b3b3"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m632.4 43.6.7-1.1h-35.5l-.2.2c-.1.1-1.2 2-3.3 5.9-2 3.9-4.4 9.7-7.1 17.3-2.7 7.7-5.1 17.2-7.1 28.7-2.1 11.4-3.2 24.7-3.3 39.9.1 15.2 1.2 28.5 3.3 39.9 2 11.5 4.4 21 7.1 28.7 2.7 7.7 5.1 13.4 7.1 17.3 2.1 3.9 3.2 5.9 3.3 5.9l.2.4h35.5l-.7-1.3c-.1 0-.2-.1-.4-.2-.6-.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5.1-15.1 1.2-28.3 3.2-39.6 2-11.4 4.3-20.9 7-28.5 2.7-7.6 5-13.3 7.1-17.1 1-1.8 1.8-3.2 2.4-4.2.2-.5.4-.9.5-1.1.2-.3.3-.5.4-.4m-6.7 9.6c-2.1 4.6-4.3 10.6-6.7 18.2-2.4 7.5-4.4 16.5-6 27.1-1.7 10.6-2.6 22.6-2.6 36 .1 13.6.9 25.7 2.6 36.3 1.7 10.6 3.7 19.6 6.1 27.2 2.4 7.6 4.6 13.7 6.7 18.2 2.1 4.6 3.7 7.6 4.6 9h-32.2c-.6-.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5.1-15.1 1.2-28.3 3.2-39.6s4.3-20.9 7-28.5c2.8-7.6 5.2-13.3 7.1-17.1 1-1.8 1.8-3.2 2.4-4.2.2-.5.4-.9.5-1.1h32.1c-.9 1.5-2.5 4.6-4.6 9.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M665.3 43.2h-33.7c-.1 0-1.2 1.9-3.2 5.7-2.1 3.8-4.4 9.6-7.1 17.2s-5 17.2-7.1 28.5c-2 11.4-3.1 24.7-3.2 39.8.1 15.1 1.2 28.4 3.2 39.8 2.1 11.4 4.4 21 7.1 28.6 2.7 7.7 5 13.4 7.1 17.2 2 3.9 3.1 5.8 3.2 5.8h33.7c-.1 0-1.2-1.9-3.2-5.8-2.1-3.8-4.4-9.6-7.1-17.2-2.7-7.7-5-17.2-7.1-28.6-2-11.4-3.1-24.7-3.2-39.8.1-15.1 1.2-28.4 3.2-39.8 2.1-11.4 4.4-20.9 7.1-28.5 2.7-7.7 5-13.4 7.1-17.2 2-3.8 3.1-5.7 3.2-5.7z",
    style: {
      fill: "#595959"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m665.9 43.6.9-1.1h-35.5l-.2.2c-.1.1-1.2 2-3.3 5.9-2 3.9-4.4 9.7-7.1 17.3-2.7 7.7-5.1 17.2-7.1 28.7-2.1 11.4-3.2 24.7-3.3 39.9.1 15.2 1.2 28.5 3.3 39.9 2 11.5 4.4 21 7.1 28.7 2.7 7.7 5.1 13.4 7.1 17.3 2.1 3.9 3.2 5.9 3.3 5.9l.2.4h35.5l-.9-1.3c.1 0 0-.1-.2-.2-.6-.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5.1-15.1 1.2-28.3 3.2-39.6 2-11.4 4.3-20.9 7-28.5 2.7-7.6 5-13.3 7.1-17.1 1-1.8 1.8-3.2 2.4-4.2.2-.5.4-.9.5-1.1l.2-.4m-6.6 9.6c-2.1 4.6-4.3 10.6-6.6 18.2-2.3 7.5-4.3 16.5-6 27.1-1.6 10.6-2.5 22.6-2.6 36 .1 13.6.9 25.7 2.6 36.3 1.7 10.6 3.7 19.6 6 27.2 2.4 7.6 4.6 13.7 6.7 18.2 2.1 4.6 3.7 7.6 4.6 9h-32c-.6-.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5.1-15.1 1.2-28.3 3.2-39.6s4.3-20.9 7-28.5c2.7-7.6 5-13.3 7.1-17.1 1-1.8 1.8-3.2 2.4-4.2.2-.5.4-.9.5-1.1h32c-1 1.5-2.6 4.6-4.7 9.2z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(590.106 107.299)",
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "\n    B\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(590.106 124.799)",
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "\n    R\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(590.106 142.149)",
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "\n    A\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(590.563 159.749)",
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "\n    S\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(590.563 177.199)",
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "\n    S\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(628.55 117.449)",
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "\n    I\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(624.906 134.85)",
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "\n    R\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(624.451 152.449)",
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "\n    O\n  "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(624.906 169.85)",
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "\n    N\n  "), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M662.4 61.8c-1-2-2.6-3.4-4.8-4.2l-5.3 15.7c1 .4 1.9.5 2.8.5 1.8-.1 3.3-.6 4.7-1.5 1.4-1 2.4-2.3 3-4.1.7-2.2.6-4.4-.4-6.4zm-71.9-4.1c-.9-.3-1.8-.5-2.7-.5-1.8 0-3.4.5-4.8 1.5-1.5 1-2.5 2.3-3.2 4.1-.7 2.2-.6 4.4.5 6.4 1 2 2.5 3.4 4.6 4.2l5.6-15.7zm-.2 153.5-5.3-15.7c-2.2.8-3.9 2.2-4.8 4.2-1 2-1.2 4.1-.5 6.4.6 1.8 1.6 3.1 3 4.1 1.4 1 2.9 1.5 4.6 1.5 1.1 0 2.1-.2 3-.5zm69.5-14.6c-1.5-1-3.1-1.5-4.8-1.5-.9 0-1.8.2-2.7.5l5.6 15.7c2.1-.8 3.7-2.2 4.6-4.2s1.1-4.1.5-6.4c-.7-1.8-1.7-3.2-3.2-4.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.797 43.671h-33.5v182.7h33.5v-91.4z",
    style: {
      fill: "#b3b3b3"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.497 49.371v-6.4h-35v184.2h35v-177.8m-1.4-4.9v181.3h-32.1V44.571h32.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.497 43.671h-33.7v182.7h33.7v-91.4z",
    style: {
      fill: "#595959"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.297 49.371v-6.4h-35.2v184.2h35.2v-177.8m-1.5-4.9v181.3h-32.2V44.571h32.2z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 127.204,
    y: 107.77,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     B  "), /*#__PURE__*/React.createElement("text", {
    x: 127.204,
    y: 125.27,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     R  "), /*#__PURE__*/React.createElement("text", {
    x: 127.204,
    y: 142.62,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     A  "), /*#__PURE__*/React.createElement("text", {
    x: 127.66,
    y: 160.22,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     S  "), /*#__PURE__*/React.createElement("text", {
    x: 127.66,
    y: 177.67,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     S  "), /*#__PURE__*/React.createElement("text", {
    x: 165.749,
    y: 117.92,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     I  "), /*#__PURE__*/React.createElement("text", {
    x: 162.104,
    y: 135.32,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     R  "), /*#__PURE__*/React.createElement("text", {
    x: 161.649,
    y: 152.92,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     O  "), /*#__PURE__*/React.createElement("text", {
    x: 162.104,
    y: 170.32,
    style: {
      fontSize: "16.3971px",
      fontFamily: "'Arial-BoldMT'",
      fill: "#fff"
    }
  }, "     N  "), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.297 74.671v-16.5c-2.4.1-4.4.9-5.9 2.4-1.6 1.6-2.4 3.6-2.5 6 .1 2.3.9 4.3 2.5 5.8 1.5 1.5 3.5 2.3 5.9 2.3zm73.1-14.1c-1.6-1.6-3.6-2.4-5.9-2.5v16.6c2.4-.1 4.3-.9 5.9-2.4 1.6-1.6 2.4-3.5 2.5-5.8-.1-2.4-.9-4.4-2.5-5.9zm-73.1 151.6v-16.8c-2.4.1-4.4.9-5.9 2.5-1.6 1.6-2.4 3.6-2.5 5.9.1 2.4.9 4.3 2.5 5.9 1.5 1.6 3.5 2.4 5.9 2.5zm73.1-14.3c-1.6-1.6-3.6-2.4-5.9-2.5v16.8c2.4-.1 4.3-.9 5.9-2.5 1.6-1.6 2.4-3.6 2.5-5.9-.1-2.4-.9-4.4-2.5-5.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399 246.1c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.99905 1.00095)",
    x: 386.835,
    y: 259.421,
    style: {
      strokeWidth: 0.99905,
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "     2"), /*#__PURE__*/React.createElement("path", {
    d: "M157.497 246.571c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.99905 1.00095)",
    x: 145.102,
    y: 259.892,
    style: {
      strokeWidth: 0.99905,
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "     1"), /*#__PURE__*/React.createElement("path", {
    d: "M640.3 246.1c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 627.768 259.668)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    3\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem13C);
export default __webpack_public_path__ + "static/media/item13c.f8307b6c440fe6da01e139ac7b077a77.svg";
export { ForwardRef as ReactComponent };